var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        "max-width": "900px",
        scrollable: "",
        value: _vm.item !== null,
        transition: false,
        persistent: false,
      },
      on: {
        "click:outside": function ($event) {
          return _vm.$emit("close")
        },
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          )
            return null
          return _vm.$emit("close")
        },
      },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "overflow-y-hidden",
          attrs: { "min-height": "620px", loading: _vm.isLoading },
        },
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _vm._v("Отправленные данные аккаунта "),
              _c("span", [_vm._v(" ")]),
              _vm.item.actionAuthor.id && _vm.item.actionAuthor.id !== "N/A"
                ? _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          name: "page-account",
                          params: { id: _vm.item.actionAuthor.id },
                        },
                        title: "Открыть",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.convertToPhone(_vm.item.actionAuthor.login)
                          ) +
                          " "
                      ),
                    ]
                  )
                : _vm.item.actionAuthor.login !== "N/A"
                ? _c("p", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.convertToPhone(_vm.item.actionAuthor.login)
                        ) +
                        " "
                    ),
                  ])
                : _vm._e(),
              _c("span", [_vm._v(" ")]),
              _vm._v(' "' + _vm._s(_vm.item.actionAuthor.ip) + '" '),
            ],
            1
          ),
          _vm.item.payload?.data
            ? _c("v-card-text", [
                _c(
                  "div",
                  { staticStyle: { margin: "10px" } },
                  [
                    _c("VueJsonPretty", {
                      attrs: {
                        data: _vm.item.payload.data,
                        deep: 1,
                        showLineNumber: "",
                        showIcon: "",
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _c(
            "v-card-actions",
            [
              _vm._t("actions", function () {
                return [
                  _c(
                    "v-btn",
                    {
                      attrs: { justify: "space-around" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("close")
                        },
                      },
                    },
                    [_vm._v(" Закрыть ")]
                  ),
                  _c("v-spacer"),
                  _vm.link
                    ? _c(
                        "v-btn",
                        {
                          attrs: { to: _vm.link, color: "primary darken-2" },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("close")
                            },
                          },
                        },
                        [_vm._v(" Перейти к сущности ")]
                      )
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }